import cloneDeep from 'lodash/cloneDeep'

import {
  CREATE_THEME_STATE,
  DESTROY_THEME_STATE,

  SET_THEME_FONT,
  SET_THEME_COLOR,
  SET_THEME_ELEVATION,
  SET_THEME_ROUNDNESS,
  SET_THEME_SPACING,

  SAVE_THEME_CHANGES_REQUEST,
  SAVE_THEME_CHANGES_DATA_MERGE,
  SAVE_THEME_CHANGES_SUCCESS,
  SAVE_THEME_CHANGES_COMPLETE
} from 'actions/theme'

const createUntouchedState = (state) => {
  return cloneDeep({
    hasUnsavedChanges: false,
    theme: state.theme
  })
}

export default (state, action) => {
  switch (action.type) {
    case CREATE_THEME_STATE:
      return {
        ...state,
        untouchedState: createUntouchedState(state)
      }

    case DESTROY_THEME_STATE:
      return { ...state, ...state.untouchedState }

    case SET_THEME_FONT:
      return {
        ...state,
        hasUnsavedChanges: true,
        theme: {
          ...state.theme,
          fonts: {
            ...state.theme.fonts,
            [action.key]: action.value
          }
        }
      }

    case SET_THEME_COLOR:
      return {
        ...state,
        hasUnsavedChanges: true,
        theme: {
          ...state.theme,
          colors: {
            ...state.theme.colors,
            [action.key]: action.value
          }
        }
      }

    case SET_THEME_ELEVATION:
      return {
        ...state,
        hasUnsavedChanges: true,
        theme: {
          ...state.theme,
          elevation: action.value
        }
      }

    case SET_THEME_ROUNDNESS:
      return {
        ...state,
        hasUnsavedChanges: true,
        theme: {
          ...state.theme,
          roundness: action.value
        }
      }

    case SET_THEME_SPACING:
      return {
        ...state,
        hasUnsavedChanges: true,
        theme: {
          ...state.theme,
          spacing: action.value
        }
      }

    case SAVE_THEME_CHANGES_REQUEST:
      return { ...state, isSaving: true }

    case SAVE_THEME_CHANGES_DATA_MERGE:
      return (() => {
        const newState = {
          ...state,
          hasUnsavedChanges: false
        }

        return {
          ...newState,
          untouchedState: createUntouchedState(newState)
        }
      })()

    case SAVE_THEME_CHANGES_SUCCESS:
      return { ...state, isSaving: false, isSavingSuccessful: true }

    case SAVE_THEME_CHANGES_COMPLETE:
      return { ...state, isSavingSuccessful: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/theme.js